import { DropDownButton, DropDownButtonItem } from "@progress/kendo-react-buttons"
import { useAppDispatch } from "../../store"
import { sendConfirmationEmail, reminderEmailSent, sendReminderCall } from "../../containers/MotBooking/bookingSlice"
import { useLocation } from "react-router-dom"

const BookingReminderActivity = ({
    bookingId,
    isEmailEmpty,
}: {
    bookingId: number
    isEmailEmpty: boolean
}) => {
    const dispatch = useAppDispatch()
    const location = useLocation()

    const executItemAction = (id: number, type: string) => {
        switch (type) {
            case "Call reminder":
                dispatch(sendReminderCall(id, true, location.pathname))
                break
            case "Send Email Confirmation" :
            case "Resend Email Confirmation":
                dispatch(sendConfirmationEmail(id, location.pathname))
                break
            case "Send Email Reminder":
                dispatch(reminderEmailSent(id, location.pathname))
                break
            default:
        }
    }

    const ItemRender = (props: any) => {
        const { item } = props
        const bookingID = item["data-id"]
        return (
            <div onClick={() => executItemAction(bookingID, item.text)} className="p-1">
                {" "}
                <span className="pe-2">
                    <i className={item.iconClass} />
                </span>{" "}
                {item.text}
            </div>
        )
    }

    return (
        <div className="col-xs-12 col-sm-4 example-col">
            <DropDownButton
                className="drop-down-btn"
                themeColor="tertiary"
                fillMode="flat"
                iconClass="k-icon k-i-more-vertical"
            >
                {[
                    {
                        title: "Call reminder",
                        icons: "fa fa-phone",
                        isHidden: false,
                    },
                    {
                        title: "Send Email Confirmation",
                        icons: "fa fa-envelope",
                        isHidden: isEmailEmpty,
                    },
                    {
                        title: "Send Email Reminder",
                        icons: "fa fa-bell",
                        isHidden: isEmailEmpty,
                    },
                ].map((activityAction) => !activityAction.isHidden && <DropDownButtonItem
                    render={ItemRender}
                    iconClass={activityAction.icons}
                    text={activityAction.title}
                    data-id={bookingId} />
                )}
            </DropDownButton>
        </div>
    )
}

export default BookingReminderActivity
